import React, { Fragment, useState, useEffect, useRef, useContext } from 'react';
import { Btn, H4, P, Image, Alerts } from '../AbstractElements';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import logoWhite from '../assets/images/logo/logo.png';
import logoDark from '../assets/images/logo/logo_dark.png';

import man from '../assets/images/dashboard/profile.png';

import useAuth from '../Hooks/useAuth';
import axios from '../api/axios';
import { QRCodeSVG } from 'qrcode.react';
import useToggle from '../Hooks/useToggle';
import Spinner from '../Components/Common/Component/Spinner';
import CustomizerContext from '../_helper/Customizer';
import { Activate2FA, Enable2FA } from '../Constant';
import TotpForm from './TotpForm';
const LOGIN_URL = '/auth/login';


//import QRCode from 'qrcode.react';

const TwoFAForm = ({ logoClassMain }) => {

  const { setAuth } = useAuth();
  
  const [check, toggleCheck] = useToggle('persist', true);

  const navigate = useNavigate();
  const location = useLocation();
  const dashboard = "/dashboard/default/Ng";
  const from = location.state?.from?.pathname || dashboard;
  const userRef = useRef();
  const errRef = useRef();

  const { auth0_profile } = useAuth();

  const [loading, setLoading] = useState(false);
  //const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const [errMsg, setErrMsg] = useState('');

  const [otpCode, setOtpCode] = useState('');

  const [qrCodeUrl, setQrCodeUrl] = useState(null);
  const [error, setError] = useState('');  

  useEffect(() => {
    if (!auth0_profile) {
      navigate('/', { replace: true });
      return;
    }

    // Now check the properties if auth0_profile is not null
    if (!auth0_profile.email || auth0_profile.is_2fa_enabled) {
      navigate('/', { replace: true });
    }
      /* userRef.current.focus();*/
  }, [auth0_profile, navigate]) 

  useEffect(() => {
      setErrMsg('');
  }, [otpCode])

  const handleSetup2FA = async () => {
   try {
        setLoading(true); 
        
        const email = auth0_profile.email;
        
        const response = await axios.post('/auth/setup-2fa',
            JSON.stringify({ email }),
          {
              headers: { 'Content-Type': 'application/json', },
              withCredentials: true
          } 
        );

        const data = await response.data.data;
        if (data.qr_code_url) {
          // Display the QR code URL in an <img> tag for the user to scan with Google Authenticator or similar app
          setQrCodeUrl(data);
        }
    } catch (err) {
      
        if (!err?.response) {
            setErrMsg('No Server Response');
        } else if (err.response?.status === 422) {
            setErrMsg('Missing Username or Password');
        } else if (err.response?.status === 401) {
            setErrMsg('Unauthorized');
        } else if ((err.response && err.response.status === 400) || (err.response && err.response.status === 404)) {
            setErrMsg(err.response.data.detail);
        } else {
            setErrMsg('Login Failed');
        }
    } 
    finally {
      setLoading(false);
    }
  };

  /* const handleVerify2FA = async (e) => {
    e.preventDefault();
    try {
        setLoading(true); 

        const email = auth0_profile.email;
        const otp = otpCode

        const response = await axios.post('/auth/verify-2fa',
            JSON.stringify({ email, otp }),
          {
              headers: { 'Content-Type': 'application/json', },
              withCredentials: true
          } 
        );

        const data = await response.data.data;
        if (data.message === "2FA successful, you are logged in") {
          setErrMsg(data.message);
          navigate(from, { replace: true });
        }
    } catch (err) {
      
        if (!err?.response) {
            setErrMsg('No Server Response');
        } else if (err.response?.status === 422) {
            setErrMsg('Missing Username or Password');
        } else if (err.response?.status === 401) {
            setErrMsg('Unauthorized');
        } else if ((err.response && err.response.status === 400) || (err.response && err.response.status === 404)) {
            setErrMsg(err.response.data.detail);
        } else {
            setErrMsg('Login Failed');
        }
    } 
    finally {
      setLoading(false);
    }
  }; */

  const handleClick = async (e) => {
    e.preventDefault();
    setLoading(true);
    console.log(otpCode);
    
    // Simulate an async operation
    setTimeout(() => {
      alert("Password reset successfully!");
      setLoading(false);
    }, 2000); // Simulates a 2-second loading time
  };
  
  return (
    <Fragment>
      <div className='login-card'>
        <div>
          <div>
            <Link className={`logo ${logoClassMain ? logoClassMain : ''}`} to={process.env.PUBLIC_URL}>
              <Image attrImage={{ className: 'img-fluid for-light', src: logoWhite, alt: 'looginpage' }} />
              <Image attrImage={{ className: 'img-fluid for-dark', src: logoDark, alt: 'looginpage' }} />
            </Link>
          </div>

          <div className='login-main'>
            {errMsg && 
              <Alerts attrAlert={{ color: 'danger ' }} >
                <p ref={errRef} className={errMsg ? "errmsg" : "offscreen"} aria-live="assertive">{errMsg}</p>
              </Alerts>
            }

            {error && <p style={{ color: 'red' }}>{error}</p>}
          
            <div>
              <H4>Setup Two-Factor Authentication (2FA) </H4>
              <P>({process.env.REACT_APP_BASE_NAME})</P>
              
              {!qrCodeUrl && (
                <>
                  <p>Click on the authentication button below and scan the QR code</p>
                  <Btn attrBtn={{ color: 'primary', 
                    className: 'd-block w-100 mt-2', 
                    disabled:loading, 
                    onClick: handleSetup2FA }}>
                    {loading ? <Spinner /> : `${Enable2FA}`}
                  </Btn>

                  <P attrPara={{ className: 'text-center mt-2 ' }}>
                    <Link className='ms-2 text-warning' to={dashboard}>
                      Skip 2FA
                    </Link>
                  </P>
                </>
              )}

              {qrCodeUrl && (
                <div>
                  <p>Scan this QR code with your authenticator app</p>
                  <div className='text-center'>
                    <QRCodeSVG value={qrCodeUrl.qr_code_url} size={256} />
                  </div>
                  
                  <Alerts attrAlert={{ color: 'info ' }} >
                    <p>If you can't scan QR code, use this in your authenticator app:</p>
                    <p><strong>{qrCodeUrl.code}</strong></p>
                  </Alerts>

                  <TotpForm onSubmit={undefined} displayImage={false} />

                  {/* <Form className='theme-form login-form' onSubmit={handleVerify2FA}>
                    <FormGroup>
                      <Input className='form-control' type='number'
                        placeholder='Enter OTP Code'
                        onChange={(e) => setOtpCode(e.target.value)} 
                        value={otpCode}
                        autoComplete="off" required/>
                      
                    </FormGroup>

                    <FormGroup>
                      <Btn attrBtn={{ color: 'primary', 
                        className: 'd-block w-100 mt-2', 
                        disabled:loading }}>
                        {loading ? <Spinner /> : `${Activate2FA}`}
                      </Btn>
                    </FormGroup>

                  </Form> */}
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default TwoFAForm;
